export default __webpack_public_path__ + "static/media/alert1.6fc01ba0.mp3";